// src/firebaseClient.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
// Note: Firebase Crashlytics is not available for web - only for native mobile apps
// For web error tracking, use Sentry or Firebase Performance Monitoring

// Config taken from your Firebase project (FIREBASE_WEBAPP_CONFIG)
const firebaseConfig = {
  apiKey: "AIzaSyDf0Eo_jI_SHOoABHR0INL6v08h3cblb8M",
  authDomain: "central-control-system-478401.firebaseapp.com",
  projectId: "central-control-system-478401",
  storageBucket: "central-control-system-478401.firebasestorage.app",
  messagingSenderId: "284627660618",
  appId: "1:284627660618:web:579be36bad396e1d5b5bb3",
};

// Avoid re-initializing in hot-reload / multiple imports
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const db = getFirestore(app);
/** Match the region where Cloud Functions are deployed (default us-central1). */
const FUNCTIONS_REGION = String(import.meta.env.VITE_FUNCTIONS_REGION || "us-central1").trim();
export const functions = getFunctions(app, FUNCTIONS_REGION);
export const storage = getStorage(app);
export const auth = getAuth(app);

if (import.meta.env.VITE_USE_FUNCTIONS_EMULATOR === "true") {
  const host = import.meta.env.VITE_FUNCTIONS_EMULATOR_HOST || "127.0.0.1";
  const port = Number(import.meta.env.VITE_FUNCTIONS_EMULATOR_PORT || 5001);
  try {
    connectFunctionsEmulator(functions, host, port);
  } catch (_error) {
    // Ignore repeated emulator connection attempts during HMR.
  }
}

// Note: Firebase Crashlytics is not available for web applications
// It's only available for native mobile apps (iOS/Android)
// For web error tracking, use:
// - Sentry (recommended for web)
// - Firebase Performance Monitoring
// - Custom error reporting endpoint

export default app;
